var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCaution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    fill: "none",
    viewBox: "0 0 26 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeLinejoin: "round",
    d: "M24.148 18.219L15.25 3.26c-1-1.68-3.499-1.68-4.498 0L1.85 18.22C.853 19.899 2.102 22 4.102 22H21.9c2 0 3.249-2.1 2.25-3.781z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M13.75 16h-1.5V8.5h1.5V16zm0 2.5h-1.5V17h1.5v1.5z"
  }));
}
export default SvgIconCaution;